// Dictionnaires de données aléatoires pour les logements générés sur la carte

export const accommodationTitles = [
  // Chambres en colocation moderne
  "Chambre 12m² en colocation moderne",
  "Chambre meublée 11m² coloc centre-ville",
  "Chambre 13m² colocation rénovée",
  "Chambre 10m² coloc proche transports",
  "Chambre lumineuse 12m² en colocation",
  "Chambre 11m² coloc tout équipée",
  "Chambre cosy 13m² en colocation",
  "Chambre 12m² coloc quartier étudiant",
  "Chambre 10m² colocation calme",
  "Chambre moderne 11m² en coloc",

  // Chambres colocation résidences
  "Chambre 12m² résidence colocation",
  "Chambre 13m² coloc résidence neuve",
  "Chambre 11m² résidence étudiante",
  "Chambre 10m² coloc résidence sécurisée",
  "Chambre meublée 12m² résidence moderne",
  "Chambre 13m² résidence services inclus",
  "Chambre 11m² coloc résidence standing",
  "Chambre 10m² résidence colocation",
  "Chambre 12m² résidence étudiante équipée",
  "Chambre 13m² coloc résidence calme",

  // Chambres colocation appartements
  "Chambre 11m² coloc appartement T4",
  "Chambre 12m² en colocation T5",
  "Chambre 10m² coloc appartement rénové",
  "Chambre 13m² colocation spacieuse",
  "Chambre 12m² coloc appart moderne",
  "Chambre 11m² en colocation lumineuse",
  "Chambre 10m² coloc appartement centre",
  "Chambre 13m² colocation tout confort",
  "Chambre 12m² coloc appart design",
  "Chambre 11m² en colocation tranquille",

  // Chambres colocation maisons
  "Chambre 12m² coloc maison avec jardin",
  "Chambre 13m² en colocation maison",
  "Chambre 11m² coloc maison rénovée",
  "Chambre 10m² colocation maison calme",
  "Chambre 12m² coloc maison moderne",
  "Chambre 13m² en coloc maison standing",
  "Chambre 11m² colocation maison centre",
  "Chambre 10m² coloc maison familiale",
  "Chambre 12m² colocation maison sécurisée",
  "Chambre 13m² coloc maison avec terrasse",

  // Chambres colocation spécialisées étudiants
  "Chambre 11m² coloc internationale",
  "Chambre 12m² coloc étudiants Erasmus",
  "Chambre 10m² colocation jeunes actifs",
  "Chambre 13m² coloc étudiants/stagiaires",
  "Chambre 12m² colocation multiculturelle",
  "Chambre 11m² coloc étudiants master",
  "Chambre 10m² colocation campus proche",
  "Chambre 13m² coloc étudiants doctorants",
  "Chambre 12m² colocation jeunes pros",
  "Chambre 11m² coloc étudiants ingénieurs",

  // Chambres colocation premium
  "Chambre 13m² coloc haut standing",
  "Chambre 12m² colocation luxe meublée",
  "Chambre 11m² coloc premium services",
  "Chambre 10m² colocation design moderne",
  "Chambre 13m² coloc executive étudiants",
  "Chambre 12m² colocation confort optimal",
  "Chambre 11m² coloc premium équipée",
  "Chambre 10m² colocation standing centre",
  "Chambre 13m² coloc prestige étudiante",
  "Chambre 12m² colocation elite moderne",

  // Chambres colocation spécifiques
  "Chambre 11m² coloc proche universités",
  "Chambre 12m² colocation zone campus",
  "Chambre 10m² coloc quartier universitaire",
  "Chambre 13m² colocation étudiante idéale",
  "Chambre 12m² coloc transport direct fac",
  "Chambre 11m² colocation vie étudiante",
  "Chambre 10m² coloc ambiance conviviale",
  "Chambre 13m² colocation studieuse",
  "Chambre 12m² coloc communauté étudiante",
  "Chambre 11m² colocation réseau étudiant",

  // Chambres colocation commodités
  "Chambre 12m² coloc toutes commodités",
  "Chambre 13m² colocation équipée WiFi",
  "Chambre 11m² coloc ménage inclus",
  "Chambre 10m² colocation charges comprises",
  "Chambre 12m² coloc internet haut débit",
  "Chambre 13m² colocation espaces communs",
  "Chambre 11m² coloc cuisine équipée",
  "Chambre 10m² colocation laverie commune",
  "Chambre 12m² coloc salon spacieux",
  "Chambre 13m² colocation bureau partagé"
];

export const accommodationDescriptions = [
  // Descriptions spécialisées colocation
  "Chambre en colocation conviviale, colocataires étudiants sympas",
  "Colocation moderne avec espaces communs spacieux et équipés",
  "Chambre meublée dans coloc calme, ambiance studieuse garantie",
  "Colocation internationale, parfaite pour rencontres et échanges culturels",
  "Chambre lumineuse en colocation, cuisine équipée et salon confortable",
  "Colocation étudiante idéale, proche fac et transports en commun",
  "Chambre dans coloc récente, colocataires sélectionnés avec soin",
  "Colocation design avec terrasse, ambiance jeune et dynamique",
  "Chambre cosy en colocation, charges incluses et internet haut débit",
  "Colocation standing avec services, ménage communs inclus",

  "Chambre en colocation mixte, équilibre études et vie sociale",
  "Colocation sécurisée avec digicode, colocataires respectueux",
  "Chambre meublée style scandinave, colocation zen et organisée",
  "Colocation avec jardin privatif, barbecues entre colocataires",
  "Chambre lumineuse en colocation, cuisine américaine et salon TV",
  "Colocation étudiante premium, ascenseur et parking disponible",
  "Chambre dans colocation calme, parfaite concentration pour études",
  "Colocation moderne tout équipée, lave-linge et lave-vaisselle",
  "Chambre cocooning en colocation, ambiance familiale chaleureuse",
  "Colocation internationale Erasmus, découverte et partage culturel",

  "Chambre spacieuse en colocation, rangements optimisés inclus",
  "Colocation récente avec balcon, vue dégagée et luminosité",
  "Chambre meublée colocation, colocataires étudiants master/doctorat",
  "Colocation design industriel, loft avec caractère et cachet",
  "Chambre en colocation quartier étudiant, vie nocturne animée",
  "Colocation sélective avec entretien, garantie ambiance studieuse",
  "Chambre lumineuse en colocation, espaces verts à proximité",
  "Colocation moderne avec fibre, parfaite pour télétravail études",
  "Chambre cosy colocation, cuisine équipée et espaces de détente",
  "Colocation standing centre-ville, commerces et services proches",

  "Chambre en colocation mixte internationale, pratique langues",
  "Colocation étudiante avec règlement, respect et convivialité",
  "Chambre meublée en colocation, colocataires même tranche d'âge",
  "Colocation moderne avec terrasse, soirées et événements organisés",
  "Chambre lumineuse colocation, transport direct vers universités",
  "Colocation sécurisée résidentiel, quartier calme et verdoyant",
  "Chambre spacieuse en colocation, coin bureau personnel aménagé",
  "Colocation récente tout confort, équipements neufs et modernes",
  "Chambre cosy colocation, ambiance chaleureuse et accueillante",
  "Colocation premium services, ménage communs et maintenance inclus"
];

export const accommodationPrices = [
  // Fourchette 400-650€ avec variété
  400, 410, 420, 430, 440, 450, 460, 470, 480, 490,
  500, 510, 520, 530, 540, 550, 560, 570, 580, 590, 600,
  610, 620, 630, 640, 650,
  405, 415, 425, 435, 445, 455, 465, 475, 485, 495,
  505, 515, 525, 535, 545, 555, 565, 575, 585, 595,
  408, 418, 428, 438, 448, 458, 468, 478, 488, 498,
  508, 518, 528, 538, 548, 558, 568, 578, 588, 598,
  412, 422, 432, 442, 452, 462, 472, 482, 492, 502,
  512, 522, 532, 542, 552, 562, 572, 582, 592, 602
];

// Fonction pour générer une surface aléatoire entre 10 et 13m²
export const getRandomRoomSize = () => {
  return Math.floor(Math.random() * (13 - 10 + 1)) + 10;
};

// Fonction pour obtenir des données aléatoires cohérentes
export const getRandomAccommodationData = () => {
  const roomSize = getRandomRoomSize();
  let selectedTitle = accommodationTitles[Math.floor(Math.random() * accommodationTitles.length)];

  // Remplacer la surface dans le titre par la surface générée
  selectedTitle = selectedTitle.replace(/\d+m²/, `${roomSize}m²`);

  return {
    title: selectedTitle,
    description: accommodationDescriptions[Math.floor(Math.random() * accommodationDescriptions.length)],
    price: accommodationPrices[Math.floor(Math.random() * accommodationPrices.length)],
    surface: roomSize
  };
};

// Charges aléatoires entre 30-80€
export const getRandomCharges = () => {
  return Math.floor(Math.random() * (80 - 30 + 1)) + 30;
};